module.exports = __webpack_public_path__ + "img/10.b5394224.webp";